import axiosPost from "../axiosPost";

export const accesoGet = async (
    { gateLugarId = null, gateLugarGlobal = null } = {},
    credentials
) => {
    const body = {
        service: "GateLugarGet",
        params: {
            gateLugarId,
            merchantId: credentials.merchantId,
            gateLugarGlobal,
        },
    };

    return await axiosPost(body, credentials);
};
